<template>
  <div class="talent-card-container">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
      <p class="loading-text">Syncing your resume...</p>
      <p class="loading-subtext">Please wait.</p>
    </div>

    <input 
      type="file" 
      ref="fileInput" 
      @change="handleFileChange" 
      accept=".pdf" 
      style="display: none;" 
    />

    <div v-if="statusMessage && !isLoading" :class="['status-message', messageType]">{{ statusMessage }}</div>

    <div v-if="userData && userData._id">
      <light-character-card
        isWidget="true"
        v-if="userData.resumeTemplate === 'lightcharactercard'"
      />
      <dark-character-card
        isWidget="true"
        v-else-if="userData.resumeTemplate === 'darkcharactercard'"
      />
      <grey-line
        isWidget="true"
        v-else-if="userData.resumeTemplate === 'greyline'"
        class="resume-preview"
      />
      <prestige isWidget="true" v-else class="resume-preview" />
    </div>
  </div>
</template>

<script>
import organizationConfig from "@/assets/data/organization-config.js";
import GreyLine from "@/layouts/components/editor/templates/GreyLine/GreyLine.vue";
import Prestige from "@/layouts/components/editor/templates/Prestige/Prestige.vue";
import LightCharacterCard from "@/layouts/components/editor/templates/Gala/LightCharacterCard.vue";
import DarkCharacterCard from "@/layouts/components/editor/templates/Gala/DarkCharacterCard.vue";

export default {
  components: { GreyLine, Prestige, LightCharacterCard, DarkCharacterCard },
  data() {
    return {
      loggedInUserIsValid: false,
      isLoading: false,
      statusMessage: '',
      messageType: 'success',  
      selectedFile: null,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    boardSlug() {
      return this.$route.params.boardSlug;
    },
    boardUserId() {
      return this.$route.params.boardUserId;
    },
    loggedInUser() {
      return this.$store.state.auth.user;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },
  // ---- ADDED METHODS FOR SYNCING ----
  methods: {
    // This method will be called by the parent (main.vue)
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type === 'application/pdf') {
        this.selectedFile = file;
        this.uploadAndSyncResume(); 
      } else {
        this.statusMessage = 'Please select a valid PDF file.';
        this.messageType = 'error';
        this.selectedFile = null;
      }
    },

    async uploadAndSyncResume() {
      if (!this.selectedFile) {
        this.statusMessage = 'No file selected.';
        this.messageType = 'error';
        return;
      }
      this.isLoading = true;
      this.statusMessage = '';

      const api_token = localStorage.getItem('accessToken');
      const user_id = this.loggedInUser ? this.loggedInUser._id : null;
      
      if (!api_token || !user_id) {
          this.statusMessage = 'Authentication error. Please refresh and try again.';
          this.messageType = 'error';
          this.isLoading = false;
          return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('user_id', user_id);
      formData.append('api_token', api_token);

      try {
        const API_BASE_URL = process.env.VUE_APP_API_URL;
        const response = await fetch(`${API_BASE_URL}/sync-resume/`, {
          method: 'POST',
          body: formData,
        });
        
        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.detail || 'An unknown error occurred during sync.');
        }

        this.messageType = 'success';
        this.statusMessage = 'Profile synced successfully! Refreshing page...';

        setTimeout(() => {
          window.location.reload();
        }, 2000);

      } catch (error) {
        this.messageType = 'error';
        this.statusMessage = error.message;
      } finally {
        this.isLoading = false;
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = '';
        }
        this.selectedFile = null;
      }
    },
  },
};
</script>

<style scoped>
.talent-card-container {
  position: relative;
  min-height: 200px;  
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 8px; 
  transition: opacity 0.3s ease-in-out;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border-left-color: #4A90E2; 
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1.25rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.loading-subtext {
  font-size: 0.9rem;
  color: #666;
}


.status-message {
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 1rem; 
  font-weight: 500;
  text-align: center;
}

.success {
  background-color: #d4edda;
  color: #155724;
}

.error {
  background-color: #f8d7da;
  color: #721c24;
}
</style>